import { render, staticRenderFns } from "./ShareInfo.vue?vue&type=template&id=d8a78e6c&scoped=true&"
import script from "./ShareInfo.vue?vue&type=script&lang=js&"
export * from "./ShareInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShareInfo.vue?vue&type=style&index=0&id=d8a78e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a78e6c",
  null
  
)

export default component.exports